import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted } from 'vue'
import { useAlbumSourceSettingsStore } from '@remote/store/album/source-setting'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { flattenSourceList, buildSourceList } from './helper'
import SourceSetting from './SourceSetting.vue'

interface IProps {
  mask?: boolean
  closeOnMaskClick?: boolean
}
interface IEmits {
  (e: 'dialog-close'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    mask: { type: Boolean, default: true },
    closeOnMaskClick: { type: Boolean, default: false }
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { mask: boolean, closeOnMaskClick: boolean }





const { close } = usePromisifyDialog(emit)
const settings = useAlbumSourceSettingsStore()
const isLoading = computed(() => settings.isIniting)
const error = computed(() => settings.error)
// const hasError = computed(() => !!error.value.type)
const isScrapeAll = computed(() => settings.data.isScrapeAll)
const list = computed(() => flattenSourceList(buildSourceList(settings.data.scrapePaths)))
const isEmpty = computed(() => {
  if (settings.isLoading) return false
  return !settings.data.scrapePaths.length
})

function onRetry () {
  settings.refresh()
}

onMounted(() => {
  onRetry()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(SourceSetting, {
      close: _unref(close),
      mask: props.mask,
      subtitle: "相册会智能显示您添加的目录下的照片",
      "close-on-mask-click": props.closeOnMaskClick,
      "is-loading": _unref(isLoading),
      error: _unref(error),
      "is-scrape-all": _unref(isScrapeAll),
      "is-empty": _unref(isEmpty),
      list: _unref(list),
      refresh: _unref(settings).refresh,
      "add-path": _unref(settings).addPath,
      "delete-path": _unref(settings).deletePath,
      "toggle-scrape-all": _unref(settings).toggleScrapeAll
    }, null, 8, ["close", "mask", "close-on-mask-click", "is-loading", "error", "is-scrape-all", "is-empty", "list", "refresh", "add-path", "delete-path", "toggle-scrape-all"])
  ]))
}
}

})